export async function fetchCategoryInfo(API_SERVER, categoryId = 0, categoryCode = '', productCode = '') {
  const BOOKINGS_ENDPOINT = `${API_SERVER}api/bookings`;
  const response = await fetch(`${BOOKINGS_ENDPOINT}/categories/${categoryId}?categoryCode=${categoryCode}&productCode=${productCode}`)
  if (!response.ok) {
    throw new Error("Failed to fetch category info")
  }
  return response.json()
}

export async function fetchAvailableSlots(API_SERVER, date, categoryId) {
  const BOOKINGS_ENDPOINT = `${API_SERVER}api/bookings`;
  const response = await fetch(`${BOOKINGS_ENDPOINT}/slots?date=${date}&categoryId=${categoryId}`)
  if (!response.ok) {
    throw new Error("Failed to fetch available slots")
  }
  return response.json()
}


export async function createBooking(API_SERVER, bookingDetails) {
  const BOOKINGS_ENDPOINT = `${API_SERVER}api/bookings`;
  const response = await fetch(`${BOOKINGS_ENDPOINT}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(bookingDetails),
  })
  if (!response.ok) {
    throw new Error("Failed to create booking")
  }
  return response.json()
}

export async function getIpAddress() {
  try {
    const response = await fetch("https://api.ipify.org?format=json")
    const data = await response.json()
    return data.ip
  } catch (error) {
    console.error("Failed to fetch IP address:", error)
    return "unknown"
  }
}

